
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useNursingHomesByCounty(countySlug: string[] | null) {
  return useQuery({
    queryKey: ["nursing-homes-by-county", countySlug],
    queryFn: async () => {
      if (!countySlug || countySlug.length === 0) return [];

      const { data, error } = await supabase
        .from("nursing_homes")
        .select("center_name, nh_slug, county_slug")
        .in("county_slug", countySlug)
        .order("center_name");

      if (error) {
        console.error("Error fetching nursing homes:", error);
        throw new Error("Failed to fetch nursing homes");
      }

      return data || [];
    },
    enabled: !!countySlug && countySlug.length > 0,
  });
}
